// Polis, l'onglet Électorat dans la nouvelle interface (10 octobre 2026).
export default {
  chargement: 'L’électorat se lit…',
  erreur: 'L’électorat n’a pas pu se lire.',
  fermer: 'Fermer',
  reessayer: 'Réessayer',
  projetee: {
    titre: 'La participation projetée',
    legende: 'chaque vague la projette, la plus récente en tête',
    fourchette: '{bas} ~ {haut}',
    exprimes: 'soit {n} millions de suffrages exprimés sur {inscrits} millions d’inscrits',
    aria: '{jour} : {taux}, entre {bas} et {haut}',
  },
  bref: {
    aria: 'L’électorat en bref',
    participationSecteurs: 'de participation retenue, secteur par secteur',
    participationEnsemble: 'de participation retenue pour tout l’électorat',
    ecart: '{bas} ~ {haut}',
    ecartPhrase: 'l’écart de participation entre les {moins} et les {plus}',
    moinsOptimiste: 'des {nom} croient que le pays va dans le bon sens, le plus bas',
  },
  secteurs: {
    titre: 'Les secteurs',
    ordre: 'du plus grand au plus petit',
    secteur: 'Secteur',
    part: 'Part de l’électorat',
    participation: 'Participation',
    vote: 'Vote à l’élection précédente',
    optimistes: 'Optimistes pour le pays',
    voteAria: 'Vote à l’élection précédente : {detail}',
  },
  choisi: {
    surtitre: 'Secteur',
    // Le Sonar de l'élection (11 octobre 2026).
    interroger: 'Interroger ce secteur',
    part: '{part} de l’électorat',
    participation: 'participation retenue {pct}',
    vote: 'Son vote à l’élection précédente',
    pays: 'croient que le pays va dans le bon sens',
    soi: 'disent que ça va bien pour eux',
    mouvementSr: 'points depuis la référence',
    noteSansMouvement: 'État d’esprit relevé chaque samedi auprès des mêmes jumeaux ; aucun mouvement depuis la référence.',
    noteAvecMouvement: 'État d’esprit relevé chaque samedi auprès des mêmes jumeaux ; à côté de chaque chiffre, son mouvement depuis la référence.',
  },
  seul: {
    titre: 'L’électorat se lit d’un seul tenant',
    participation: 'de participation retenue',
    sansParticipation: 'Aucune participation retenue pour l’instant.',
  },
}
